/**
 * Results
 *
 * View that handles interactions within the results container
 *
 * @return {View}
 */

OT.createNS('OT.Common.Views.Results.ResultsContainer');

OT.Common.Views.Results.ResultsContainer = Backbone.ViewManager.BaseView.extend({

    el: '#search_results_container',

    events: {
        'click .applied-filter .close' : 'removeSearchFilter',
        'click .rest-name'             : 'restaurantClicked',
        'click .first-cell .offer'     : 'offerClicked',
        'click .timeslot'              : 'timeslotClicked',
        'mouseover .rest-name'         : 'createRestaurantModal',
        'mouseover .price-col .price'  : 'createPriceModal',
        'mouseover .first-cell .offer' : 'createRestaurantModal',
        'mouseover .timeslot'          : 'createOfferTooltip',
        'mouseout .rest-name'          : 'removeRestaurantModal',
        'mouseout .first-cell .offer'  : 'removeRestaurantModal',
        'mouseout .price-col .price'   : 'removePriceModal',
        'mouseout .timeslot'           : 'removeOfferTooltip',
        'click #availability_link'     : 'toggleAvailability',
        'click #clear_last_filter'     : 'undoLastFilter',
        'click #start_over'            : 'clearAllFilters'
    },

    initialize: function() {
        var _this = this;

        // Listen for result updates
        OT.Events.on('results:get', function() { _this.clearModals(); });
        OT.Events.on('scroll',      function() { _this.clearModals(); });

        // Set modal delays
        this.tooltipDelay         = 100;
        this.priceModalDelay      = 50;
        this.restaurantModalDelay = 150;
        this.removeModalDelayTime = 100;

        // Set information about filters
        this.filterLinks = this.$el.find('.header-cell-link');
        this.currentSort = OT.Search.Data.get().Request.SortString;

        this.isFilterModalShowing = false;

        // Listen for the changes to the filter modal
        OT.Events.on('modal:show', function() { _this.isFilterModalShowing = true; });
        OT.Events.on('modal:hide', function() { _this.isFilterModalShowing = false; });
    },

    /**
     * Toggle availability search/no availabilty search
     */
    toggleAvailability: function(e) {
        e.preventDefault();

        var onlyUnavailable = $(e.currentTarget).hasClass('with-availability');

        OT.Search.Params.set({
            'OnlyUnavailable': onlyUnavailable
        });

        OT.Search.Requests.Results.get();
    },

    /**
     * Delays for the modals being created and removed.
     *
     * This is so if the use hovers from one offer to another,
     * the box won't disappear and then re-appear
     */
    createModalDelay: function(delay, name, callback) {
        if(OT.Common.Helpers.isUserScrolling()) {
            return false;
        }

        if(this.modalName === undefined) {
            this.modalName = name;
        }

        if(this.modalName === name) {
            clearTimeout(this[name + 'Timeout']);
        } else {
            this.clearModals();
        }

        this.modalTimeout = setTimeout(callback, delay || 0);
        this.modalName = name;
    },

    removeModalDelay: function(delay, name) {
        var _this = this;

        clearTimeout(this.modalTimeout);

        _this[name + 'Timeout'] = setTimeout(function() {
            _this.clearModals();
        }, delay || 0);
    },

    /**
     * Create restaurant modal delay, view and remove it
     */
    createRestaurantModal: function(e) {
        var _this = this;

        if(this.filterModalIsShowing() || OT.Search.Helpers.isMapShowing()) {
            return false;
        }

        var $result     = $(e.currentTarget),
            $target     = $result.parents('.result'),
            $parent     = $target.parents('.results-set'),
            name        = $result.hasClass('offer') ? 'offer-name' : 'restaurant-name',
            resultsSet  = $parent.hasClass('pop-table') ? 'FeaturedPopRestaurants' : 'Restaurants',
            data        = OT.Search.Data.get().Results[resultsSet][$target.data('id')];

        this.createModalDelay(this.restaurantModalDelay, 'restaurantModal', function() {
            OT.Search.views.restaurantModal.setAttributes({
                $target: $target,
                templateData: data
            }).render();

            var logData = {
                position: $target.data('id') + 1
            };

            if(name === 'offer-name') {
                _.extend(logData, {
                    offerId: e.currentTarget.getAttribute('data-id')
                });
            }

            _this.logEvent(e, name +'-hover', logData);
        });
    },

    removeRestaurantModal: function() {
        this.removeModalDelay(this.removeModalDelayTime, 'restaurantModal');
    },

    /**
     * Create price modal delay, view and remove it
     */
    createPriceModal: function(e) {
        var _this = this;

        _this.createModalDelay(_this.priceModalDelay, 'priceModal', function() {
            OT.Search.views.priceModal.setAttributes({
                $target: $(e.currentTarget)
            }).render();
        });
    },

    removePriceModal: function() {
        this.removeModalDelay(this.removeModalDelayTime, 'priceModal');
    },

    /**
     * Create tooltip delay, view and remove it
     */
    createOfferTooltip: function(e) {
        var _this      = this,
            $target    = $(e.currentTarget),
            $row       = $target.parents('.result'),
            rowOffers  = $target.data('offers'),
            offerIds   = typeof rowOffers === 'number' ? [rowOffers+''] : rowOffers.split(','),
            resultsSet = $target.parents('.results-set').hasClass('pop-table') ? 'FeaturedPopRestaurants' : 'Restaurants',
            data       = {
                'Offers': []
            };


        if(offerIds[0] !== '') {
            $.each(OT.Search.Data.get().Results[resultsSet][$row.data('id')].Offers, function(i, offer) {
                if($.inArray(offer.Id+'', offerIds) !== -1) {
                    data.Offers.push(offer.Name);
                }
            });

            _this.isToolTip = true;
            _this.createModalDelay(_this.tooltipDelay, 'offerTooltip', function() {
                OT.Search.views.tooltipModal.setAttributes({
                    $target: $target,
                    templateData: data
                });

                if(!OT.Search.views.tooltipModal.$el.is('visible')) {
                    OT.Search.views.tooltipModal.render();
                }

                _this.logEvent(e, 'timeslot-hover', {
                    offerIds: (''+ $target.data('offers')).split(','),
                    time: OT.Search.Helpers.convertTimeTo24Hour($target.find('.time').text().trim()),
                    isExact: $target.find('.time').hasClass('exact'),
                    isPop: !!$target.find('.pts').length
                });
            });
        }
    },

    removeOfferTooltip: function() {
        if(this.isToolTip) {
            this.removeModalDelay(this.removeModalDelayTime, 'offerTooltip');
        }

        this.isToolTip = false;
    },

    /**
     * Checking if the filter modal is currently showing
     */
    filterModalIsShowing: function() {
        return !!this.isFilterModalShowing;
    },

    undoLastFilter: function() {
        OT.Search.sendLogRequest('_clear-last-filter', 'interaction', {});

        OT.Search.History.back();
        OT.Search.Requests.Results.get();
    },

    /**
     * Clear all search filters and fire a new search
     */
    clearAllFilters: function() {
        var isMapShowing = OT.Search.Helpers.isMapShowing();
        var metroId = OT.Search.Params.get('MetroId');
        var latitude = OT.Search.Params.get('Latitude');
        var longitude = OT.Search.Params.get('Longitude');
        var distance = OT.Search.Params.get('Distance');
        var domain = OT.Search.Params.get('Domain');
        var dateTime = OT.Search.Params.get('DateTime');
        var covers = OT.Search.Params.get('Covers');

        OT.Search.Params.clear();
        OT.Search.sendLogRequest('_clear-all-filters', 'interaction', {});
        OT.Search.Params.set('ShowMap', isMapShowing);

        if (metroId) {
            OT.Search.Params.set('MetroId', metroId);
        }

        if (latitude) {
            OT.Search.Params.set('Latitude', latitude);
        }

        if (longitude) {
            OT.Search.Params.set('Longitude', longitude);
        }

        if (distance) {
            OT.Search.Params.set('Distance', distance);
        }

        if (domain) {
            OT.Search.Params.set('Domain', domain);
        }

        if (dateTime) {
            OT.Search.Params.set('DateTime', dateTime);
        }

        if (covers) {
            OT.Search.Params.set('Covers', covers);
        }

        window.open(OT.Search.Requests.BuildUrl.queryString(OT.Search.Params.getAll()), '_self')
    },

    /**
     * Clear all modals
     */
    clearModals: function() {
        var views = ['tooltipModal', 'priceModal', 'restaurantModal'];

        _.each(views, function(view) {
            if (OT.Search.views[view] && OT.Search.views[view].el && OT.Search.views[view].el.style && OT.Search.views[view].el.style.display !== 'none') {
                OT.Search.views[view].unsetView();
            }
        });
    },

    /**
     * Trigger an event to remove the selected search filter
     */
    removeSearchFilter: function(e) {
        var $filter = $(e.currentTarget),
            filter = $filter.data('filter');

        // remove the filter from the DOM
        $filter.parent().remove();

        OT.Events.fire('filters:remove', filter);
    },

    restaurantClicked: function(e) {
        this.logEvent(e, 'restaurant-name');
    },

    offerClicked: function(e) {
        this.logEvent(e, 'offer-name', {
            offerId: e.currentTarget.getAttribute('data-id')
        });
    },

    timeslotClicked: function(e) {
        var $target = $(e.currentTarget);

        this.logEvent(e, 'timeslot', {
            offerIds: (''+ $target.data('offers')).split(','),
            time: OT.Search.Helpers.convertTimeTo24Hour($target.find('.time').text().trim()),
            isExact: $target.find('.time').hasClass('exact'),
            isPop: !!$target.find('.pts').length
        });
    },

    logEvent: function(e, type, data) {
        var $target = $(e.currentTarget).parents('.results-set'),
            viewName = '_'+ $target.data('name'),
            row = OT.Search.Data.get().Results.Restaurants[$(e.currentTarget).parents('.result').data('id')];

        OT.Search.sendLogRequest(viewName, 'interaction', _.extend({
            rid: row.Id,
            type: type,
            hasOffers: !!row.Offers.length,
            position: $(e.currentTarget).parents('.result').data('id') + 1
        }, data || {}));
    }

});
